import React from 'react';
import {
  IonButton,
  IonInput,
  IonInputPasswordToggle,
  IonItem,
  IonList,
} from '@ionic/react';
import AppPasswordQuality from '../../components/AppPasswordQuality';
import { useTranslation } from 'react-i18next';
import { cfgPasswordMinLength } from '../../utils/config';
import {uiInputMode} from "../../utils/ui";

type RegisterPersonalProps = {
  isValid: boolean;
  email: string;
  setEmail: (s: string) => void;
  phone: string;
  setPhone: (s: string) => void;
  firstName: string;
  setFirstName: (s: string) => void;
  lastName: string;
  setLastName: (s: string) => void;
  password: string;
  setPassword: (s: string) => void;
  password2: string;
  setPassword2: (s: string) => void;
  proceed: () => void;
};

export default function RegisterPersonal({
  isValid,
  email,
  setEmail,
  phone,
  setPhone,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  password,
  setPassword,
  password2,
  setPassword2,
  proceed,
}: RegisterPersonalProps) {
  const [t] = useTranslation('global');

  const useTestData = () => {
    setFirstName('John');
    setLastName('Doe');
    setPassword('qwe!"§QWE1');
    setPassword2('qwe!"§QWE1');
    setEmail('john@doe.com');
    proceed();
  };

  return (
    <>
      <h1 className="h1 ion-text-center h1plus">{t('register.personaltitle')}</h1>
      <p className="pt-2 pb-1 instructions ion-text-center">
        {t('register.personalinfo')}
      </p>
      <IonList inset={false}>
        <IonItem lines="none" className="ion-no-padding ion-pt-1">
          <IonInput
            value={firstName}
            mode={uiInputMode()}
            aria-label={t('register.firstname')!}
            placeholder={t('register.firstname')!}
            onIonInput={(e) => setFirstName(e.detail.value!)}
            type="text"
            fill="outline"
          ></IonInput>
        </IonItem>
        <IonItem lines="none" className="ion-no-padding ion-pt-1">
          <IonInput
            value={lastName}
            mode={uiInputMode()}
            aria-label={t('register.lastname')!}
            placeholder={t('register.lastname')!}
            onIonInput={(e) => setLastName(e.detail.value!)}
            type="text"
            fill="outline"
          ></IonInput>
        </IonItem>
        <IonItem lines="none" className="ion-no-padding ion-pt-1">
          <IonInput
            value={email}
            mode={uiInputMode()}
            aria-label={t('register.email')!}
            placeholder={t('register.email')!}
            onIonInput={(e) => setEmail(e.detail.value!)}
            type="email"
            fill="outline"
          ></IonInput>
        </IonItem>
        <IonItem lines="none" className="ion-no-padding ion-pt-1">
          <IonInput
            className="password"
            value={password}
            mode={uiInputMode()}
            aria-label={t('register.password')!}
            placeholder={t('register.password')!}
            onIonInput={(e) => setPassword(e.detail.value!)}
            type="password"
            fill="outline"
          >
            <IonInputPasswordToggle
              color="secondary"
              slot="end"
            ></IonInputPasswordToggle>
          </IonInput>
        </IonItem>
        <AppPasswordQuality
          minLength={cfgPasswordMinLength()}
          password={password}
        ></AppPasswordQuality>
        <IonItem lines="none" className="ion-no-padding ion-pt-1">
          <IonInput
            className="password"
            value={password2}
            mode={uiInputMode()}
            aria-label={t('register.password2')!}
            placeholder={t('register.password2')!}
            onIonInput={(e) => setPassword2(e.detail.value!)}
            type="password"
            fill="outline"
          >
            <IonInputPasswordToggle
              color="secondary"
              slot="end"
            ></IonInputPasswordToggle>
          </IonInput>
        </IonItem>
        <IonItem lines="none" className="ion-no-padding ion-pt-1">
          <IonInput
            value={phone}
            mode={uiInputMode()}
            aria-label={t('register.phone')!}
            placeholder={t('register.phone')!}
            onIonInput={(e) => setPhone(e.detail.value!)}
            type="text"
            fill="outline"
          ></IonInput>
        </IonItem>
      </IonList>

      <div className="pt-3 ion-text-center">
        <IonButton
          className={
            'btn-default btn-wide-80 ' + (isValid ? '' : 'btn-disabled')
          }
          onClick={() => proceed()}
          onDoubleClick={() => useTestData()}
        >
          {t('register.continue')}
        </IonButton>
      </div>
    </>
  );
}
